module.exports = __webpack_public_path__ + "img/sy_bg.f9afca7d.jpg";